// Supplementary translations for new sections (founder, careers, legal, clients).
// Merged into the main dictionary by translations.js.

const founder = {
  en: {
    "founder.tag": "Leadership",
    "founder.title": "Meet the Founder & CEO",
    "founder.name": "Bienvenue Ikaka Mopulunga",
    "founder.role": "Founder & Chief Executive Officer",
    "founder.subtitle": "Building a more connected, structured and technologically sovereign Africa.",
    "founder.bio_p1": "Bienvenue Ikaka Mopulunga is a Congolese entrepreneur, technology visionary and business leader, recognised for his commitment to developing digital solutions that modernise public and private institutions across Africa. He is the founder and CEO of Bigradap Group Technologies — a company specialising in information systems, data management, digital infrastructure and institutional transformation technologies.",
    "founder.bio_p2": "With more than three decades of experience in information technology, he has built deep expertise in designing platforms that improve governance, centralise data and increase administrative efficiency. Under his leadership, Bigradap Group Technologies has expanded its footprint between South Africa and the Democratic Republic of Congo, delivering solutions tailored to the realities of the African continent.",
    "founder.bio_p3": "Among his most ambitious projects is the development of SIMP (Système Intégré Multisectoriel Permanent) — a platform that connects multiple institutions around a centralised data backbone, improving civil registration, population census and the coordination of administrative and government services.",
    "founder.bio_p4": "Driven by a vision of modernising and digitally integrating Africa, Bienvenue Ikaka Mopulunga advocates for technology as a strategic instrument of economic development, institutional transparency and citizen empowerment. His work has been presented at international forums on innovation, statistics and information systems.",
    "founder.bio_p5": "Beyond his entrepreneurial journey, he is recognised for his commitment to the development of the African continent through sustainable, innovative solutions tailored to tomorrow's challenges. His ambition is to help build a more connected, structured and technologically sovereign Africa.",
    "founder.quote": "Technology is only useful when it serves a country or an enterprise better than the status quo.",
    "nav.founder": "Founder",
  },
  fr: {
    "founder.tag": "Leadership",
    "founder.title": "Le fondateur et PDG",
    "founder.name": "Bienvenue Ikaka Mopulunga",
    "founder.role": "Fondateur & Président-Directeur Général",
    "founder.subtitle": "Construire une Afrique plus connectée, structurée et souveraine sur le plan technologique.",
    "founder.bio_p1": "Bienvenue Ikaka Mopulunga est un entrepreneur, visionnaire technologique et dirigeant d'entreprise originaire de la République démocratique du Congo, reconnu pour son engagement dans le développement de solutions numériques destinées à moderniser les institutions publiques et privées à travers l'Afrique. Il est le fondateur et président-directeur général de Bigradap Group Technologies, une entreprise spécialisée dans les systèmes d'information, la gestion des données, les infrastructures numériques et les technologies de transformation institutionnelle.",
    "founder.bio_p2": "Fort de plusieurs décennies d'expérience dans le domaine des technologies de l'information, il a développé une expertise dans la conception de plateformes destinées à améliorer la gouvernance, la centralisation des données et l'efficacité administrative. Sous sa direction, Bigradap Group Technologies a étendu ses activités entre l'Afrique du Sud et la République démocratique du Congo, en proposant des solutions adaptées aux réalités du continent africain.",
    "founder.bio_p3": "Parmi ses projets les plus ambitieux figure le développement du système SIMP (Système Intégré Multisectoriel Permanent), une plateforme conçue pour connecter différentes institutions autour d'une base de données centralisée. Ce système vise notamment à améliorer la gestion de l'état civil, du recensement de la population, ainsi que la coordination des services administratifs et gouvernementaux.",
    "founder.bio_p4": "Animé par une vision de modernisation et d'intégration numérique de l'Afrique, Bienvenue Ikaka Mopulunga défend l'idée que la technologie doit être utilisée comme un outil stratégique de développement économique, de transparence institutionnelle et de valorisation des citoyens. Son travail l'a conduit à présenter plusieurs projets technologiques lors de rencontres internationales consacrées à l'innovation, aux statistiques et aux systèmes d'information.",
    "founder.bio_p5": "Au-delà de son parcours entrepreneurial, il est reconnu pour son engagement en faveur du développement du continent africain à travers des solutions durables, innovantes et adaptées aux enjeux de demain. Son ambition est de contribuer à la construction d'une Afrique davantage connectée, structurée et souveraine sur le plan technologique.",
    "founder.quote": "La technologie n'est utile que lorsqu'elle sert un État ou une entreprise mieux que le statu quo.",
    "nav.founder": "Fondateur",
  },
  ar: {
    "founder.tag": "القيادة",
    "founder.title": "المؤسس والرئيس التنفيذي",
    "founder.name": "Bienvenue Ikaka Mopulunga",
    "founder.role": "المؤسس والرئيس التنفيذي",
    "founder.subtitle": "بناء أفريقيا أكثر اتصالاً وتنظيماً وسيادة على المستوى التكنولوجي.",
    "founder.bio_p1": "Bienvenue Ikaka Mopulunga رائد أعمال كونغولي وقائد أعمال صاحب رؤية تكنولوجية، يُعرف بالتزامه بتطوير حلول رقمية لتحديث المؤسسات العامة والخاصة في جميع أنحاء أفريقيا. هو مؤسس Bigradap Group Technologies ورئيسها التنفيذي، شركة متخصصة في أنظمة المعلومات وإدارة البيانات والبنية التحتية الرقمية وتقنيات التحول المؤسسي.",
    "founder.bio_p2": "بخبرة تمتد لأكثر من ثلاثة عقود في تقنية المعلومات، طوّر خبرة عميقة في تصميم منصات تُحسّن الحوكمة وتُمركز البيانات وتُعزّز الكفاءة الإدارية. تحت قيادته، توسعت Bigradap Group Technologies في جنوب أفريقيا وجمهورية الكونغو الديمقراطية.",
    "founder.bio_p3": "من أبرز مشاريعه تطوير منصة SIMP، التي تربط مؤسسات متعددة حول عمود فقري مركزي للبيانات، مما يحسّن السجل المدني وتعداد السكان وتنسيق الخدمات الإدارية والحكومية.",
    "founder.bio_p4": "مدفوعاً برؤية تحديث أفريقيا ودمجها رقمياً، يدعو إلى استخدام التكنولوجيا أداةً استراتيجيةً للتنمية الاقتصادية والشفافية المؤسسية وتمكين المواطن.",
    "founder.bio_p5": "وراء مسيرته الريادية، يُعرف بالتزامه بتنمية القارة الأفريقية عبر حلول مستدامة ومبتكرة. هدفه: بناء أفريقيا أكثر اتصالاً وتنظيماً وسيادة تقنياً.",
    "founder.quote": "التكنولوجيا لا تكون نافعة إلا حين تخدم دولةً أو مؤسسةً أفضل من الوضع الراهن.",
    "nav.founder": "المؤسس",
  },
  zh: {
    "founder.tag": "领导团队",
    "founder.title": "创始人兼首席执行官",
    "founder.name": "Bienvenue Ikaka Mopulunga",
    "founder.role": "创始人兼首席执行官",
    "founder.subtitle": "构建一个更互联、更有结构、技术更具主权的非洲。",
    "founder.bio_p1": "Bienvenue Ikaka Mopulunga 是来自刚果民主共和国的企业家、技术远见者与商业领袖,致力于为非洲的公共与私营机构提供现代化数字解决方案。他是 Bigradap Group Technologies 的创始人兼首席执行官,该公司专注于信息系统、数据管理、数字基础设施与机构转型技术。",
    "founder.bio_p2": "在信息技术领域拥有三十多年经验,他在治理改进、数据中心化与行政效率提升的平台设计方面积累了深厚专长。在他的领导下,Bigradap Group Technologies 已在南非与刚果民主共和国扩展业务,提供契合非洲大陆现实的解决方案。",
    "founder.bio_p3": "他最具雄心的项目之一是 SIMP(多部门综合永久系统)的开发——一个将多家机构围绕集中数据中枢连接起来的平台,改善民事登记、人口普查以及行政与政府服务的协同。",
    "founder.bio_p4": "他主张技术应作为经济发展、机构透明与公民赋权的战略工具。他的工作在多个关于创新、统计与信息系统的国际论坛上展示。",
    "founder.bio_p5": "除了创业历程,他以致力于推动非洲大陆可持续发展的承诺而闻名。其抱负:帮助构建一个更互联、更有结构、技术更具主权的非洲。",
    "founder.quote": "唯有当技术比现状更好地服务于一个国家或一家企业时,它才有意义。",
    "nav.founder": "创始人",
  },
  es: {
    "founder.tag": "Liderazgo",
    "founder.title": "Conozca al Fundador y CEO",
    "founder.name": "Bienvenue Ikaka Mopulunga",
    "founder.role": "Fundador y Director Ejecutivo",
    "founder.subtitle": "Construyendo una África más conectada, estructurada y soberana en lo tecnológico.",
    "founder.bio_p1": "Bienvenue Ikaka Mopulunga es un emprendedor congoleño, visionario tecnológico y líder empresarial, reconocido por su compromiso con el desarrollo de soluciones digitales que modernizan las instituciones públicas y privadas en toda África. Es fundador y CEO de Bigradap Group Technologies, especializada en sistemas de información, gestión de datos, infraestructura digital y tecnologías de transformación institucional.",
    "founder.bio_p2": "Con más de tres décadas de experiencia en tecnologías de la información, ha desarrollado una experiencia profunda en el diseño de plataformas que mejoran la gobernanza, centralizan los datos y aumentan la eficiencia administrativa. Bajo su liderazgo, Bigradap Group Technologies ha expandido su huella entre Sudáfrica y la República Democrática del Congo.",
    "founder.bio_p3": "Entre sus proyectos más ambiciosos figura el desarrollo de SIMP, una plataforma que conecta múltiples instituciones en torno a una columna vertebral de datos centralizada, mejorando el registro civil, el censo de población y la coordinación de servicios administrativos y gubernamentales.",
    "founder.bio_p4": "Defiende que la tecnología debe usarse como instrumento estratégico de desarrollo económico, transparencia institucional y empoderamiento ciudadano. Su trabajo ha sido presentado en foros internacionales sobre innovación, estadística y sistemas de información.",
    "founder.bio_p5": "Más allá de su trayectoria empresarial, es reconocido por su compromiso con el desarrollo del continente africano a través de soluciones sostenibles e innovadoras. Su ambición: contribuir a una África más conectada, estructurada y soberana tecnológicamente.",
    "founder.quote": "La tecnología solo es útil cuando sirve a un Estado o a una empresa mejor que el statu quo.",
    "nav.founder": "Fundador",
  },
};

const careers = {
  en: {
    "nav.careers": "Careers",
    "careers.tag": "Careers",
    "careers.title": "Join the team building Africa's most trusted IT systems.",
    "careers.sub": "We are always looking for engineers, project managers and field operators who care about quality, speed and the impact of their work.",
    "careers.values_title": "What we look for",
    "careers.v1": "Engineering rigour and curiosity",
    "careers.v2": "Comfort with mission-critical and government workloads",
    "careers.v3": "Mobility across the African continent",
    "careers.v4": "Fluency in English or French (Portuguese a plus)",
    "careers.open_title": "Open roles",
    "careers.role_se": "Software Engineer · backend, mobile, biometrics",
    "careers.role_pm": "Project / Programme Manager · public sector",
    "careers.role_fe": "Field Deployment Engineer · DRC, RSA, francophone Africa",
    "careers.role_sa": "Sales & Public Sector Account Executive",
    "careers.role_se_loc": "Kinshasa / Remote",
    "careers.role_pm_loc": "Kinshasa",
    "careers.role_fe_loc": "Continental travel",
    "careers.role_sa_loc": "Kinshasa",
    "careers.apply": "Apply via email",
    "careers.email_note": "Send your CV and a short note to",
  },
  fr: {
    "nav.careers": "Carrières",
    "careers.tag": "Carrières",
    "careers.title": "Rejoignez l'équipe qui construit les systèmes IT les plus fiables d'Afrique.",
    "careers.sub": "Nous recherchons en permanence ingénieurs, chefs de projet et opérateurs terrain qui se soucient de la qualité, de la vitesse et de l'impact de leur travail.",
    "careers.values_title": "Ce que nous recherchons",
    "careers.v1": "Rigueur d'ingénieur et curiosité",
    "careers.v2": "Aisance avec les charges critiques et étatiques",
    "careers.v3": "Mobilité à l'échelle du continent africain",
    "careers.v4": "Anglais ou français courant (portugais un plus)",
    "careers.open_title": "Postes ouverts",
    "careers.role_se": "Ingénieur·e logiciel · backend, mobile, biométrie",
    "careers.role_pm": "Chef·fe de projet / programme · secteur public",
    "careers.role_fe": "Ingénieur·e déploiement terrain · RDC, RSA, Afrique francophone",
    "careers.role_sa": "Commercial·e secteur public",
    "careers.role_se_loc": "Kinshasa / Remote",
    "careers.role_pm_loc": "Kinshasa",
    "careers.role_fe_loc": "Mobilité continentale",
    "careers.role_sa_loc": "Kinshasa",
    "careers.apply": "Postuler par email",
    "careers.email_note": "Envoyez votre CV et un court mot à",
  },
  ar: {
    "nav.careers": "الوظائف",
    "careers.tag": "الوظائف",
    "careers.title": "انضم إلى الفريق الذي يبني أكثر أنظمة تقنية موثوقية في أفريقيا.",
    "careers.sub": "نبحث دائماً عن مهندسين ومديري مشاريع وعاملين ميدانيين يهتمون بالجودة والسرعة وأثر عملهم.",
    "careers.values_title": "ما نبحث عنه",
    "careers.v1": "صرامة هندسية وفضول",
    "careers.v2": "الراحة مع أعباء العمل الحرجة والحكومية",
    "careers.v3": "التنقل عبر القارة الأفريقية",
    "careers.v4": "إتقان الإنجليزية أو الفرنسية (البرتغالية ميزة)",
    "careers.open_title": "الوظائف المتاحة",
    "careers.role_se": "مهندس برمجيات · الواجهة الخلفية، الجوال، البيومتريا",
    "careers.role_pm": "مدير مشاريع / برامج · القطاع العام",
    "careers.role_fe": "مهندس نشر ميداني · الكونغو، جنوب أفريقيا، أفريقيا الفرنكوفونية",
    "careers.role_sa": "مدير حسابات القطاع العام والمبيعات",
    "careers.role_se_loc": "كينشاسا / عن بُعد",
    "careers.role_pm_loc": "كينشاسا",
    "careers.role_fe_loc": "تنقل قاري",
    "careers.role_sa_loc": "كينشاسا",
    "careers.apply": "تقدم عبر البريد الإلكتروني",
    "careers.email_note": "أرسل سيرتك الذاتية ورسالة قصيرة إلى",
  },
  zh: {
    "nav.careers": "招聘",
    "careers.tag": "招聘",
    "careers.title": "加入打造非洲最值得信赖 IT 系统的团队。",
    "careers.sub": "我们一直在寻找关注质量、速度与工作影响力的工程师、项目经理与现场运维人员。",
    "careers.values_title": "我们看重",
    "careers.v1": "工程严谨与好奇心",
    "careers.v2": "对关键任务与政府级负载的从容",
    "careers.v3": "在非洲大陆的流动性",
    "careers.v4": "英语或法语流利(葡萄牙语加分)",
    "careers.open_title": "开放职位",
    "careers.role_se": "软件工程师 · 后端、移动、生物识别",
    "careers.role_pm": "项目 / 计划经理 · 公共部门",
    "careers.role_fe": "现场部署工程师 · 刚果(金)、南非、法语非洲",
    "careers.role_sa": "销售与公共部门客户经理",
    "careers.role_se_loc": "金沙萨 / 远程",
    "careers.role_pm_loc": "金沙萨",
    "careers.role_fe_loc": "大陆出差",
    "careers.role_sa_loc": "金沙萨",
    "careers.apply": "通过邮件申请",
    "careers.email_note": "发送您的简历与简短说明至",
  },
  es: {
    "nav.careers": "Carreras",
    "careers.tag": "Carreras",
    "careers.title": "Únase al equipo que construye los sistemas TI más confiables de África.",
    "careers.sub": "Buscamos constantemente ingenieros, gestores de proyectos y operadores de campo que se preocupen por la calidad, la velocidad y el impacto de su trabajo.",
    "careers.values_title": "Lo que buscamos",
    "careers.v1": "Rigor de ingeniería y curiosidad",
    "careers.v2": "Confort con cargas críticas y gubernamentales",
    "careers.v3": "Movilidad por el continente africano",
    "careers.v4": "Inglés o francés fluidos (portugués un plus)",
    "careers.open_title": "Vacantes",
    "careers.role_se": "Ingeniero/a de software · backend, móvil, biometría",
    "careers.role_pm": "Gestor/a de proyecto / programa · sector público",
    "careers.role_fe": "Ingeniero/a de despliegue en campo · RDC, RSA, África francófona",
    "careers.role_sa": "Comercial sector público",
    "careers.role_se_loc": "Kinshasa / Remoto",
    "careers.role_pm_loc": "Kinshasa",
    "careers.role_fe_loc": "Movilidad continental",
    "careers.role_sa_loc": "Kinshasa",
    "careers.apply": "Postular por email",
    "careers.email_note": "Envíe su CV y una nota breve a",
  },
};

const legal = {
  en: {
    "nav.legal": "Legal",
    "legal.tag": "Legal",
    "legal.title": "Privacy & legal notices.",
    "legal.intro": "Bigradap Group Technologies (PTY) LTD respects the privacy of every visitor. This page describes how we collect, store and process personal data on bigradapgroup.com — in compliance with POPIA (South Africa) and the GDPR (European Union).",
    "legal.controller_title": "Data controller",
    "legal.controller_body": "Bigradap Group Technologies (PTY) LTD — Av. Col Mondjiba 2366, C/Gombe, Kinshasa, DRC. Email: info@bigradapgroup.com.",
    "legal.data_title": "What we collect",
    "legal.data_body": "When you use the contact form we store the name, email, organisation, country, phone, subject, message and selected language. We do not use third-party trackers on bigradapgroup.com beyond essential analytics. Cookies are limited to a locale preference (bigradap.locale) and an admin session token (bigradap.admin.token) for internal staff only.",
    "legal.purpose_title": "Why we collect it",
    "legal.purpose_body": "To answer your enquiries and to keep an audit trail of business communications. We do not sell or share your data with third parties.",
    "legal.retention_title": "How long we keep it",
    "legal.retention_body": "Contact submissions are stored for 36 months and then deleted, unless an active engagement requires longer retention.",
    "legal.rights_title": "Your rights",
    "legal.rights_body": "Under POPIA and the GDPR you can request access, correction or deletion of your personal data, and lodge a complaint with the relevant supervisory authority. Write to info@bigradapgroup.com with your request.",
    "legal.security_title": "Security",
    "legal.security_body": "All traffic on bigradapgroup.com is encrypted via HTTPS. Submissions are stored in an access-restricted MongoDB instance. Administrative access is protected by JWT authentication, bcrypt password hashing and brute-force lockout.",
    "legal.terms_title": "Terms",
    "legal.terms_body": "Content on this website is the property of Bigradap Group Technologies and cannot be reproduced without prior written consent. Brand names and logos belong to their respective owners and are used for illustrative purposes only.",
  },
  fr: {
    "nav.legal": "Légal",
    "legal.tag": "Légal",
    "legal.title": "Mentions légales & confidentialité.",
    "legal.intro": "Bigradap Group Technologies (PTY) LTD respecte la vie privée de chaque visiteur. Cette page décrit la manière dont nous collectons, stockons et traitons les données personnelles sur bigradapgroup.com — en conformité avec POPIA (Afrique du Sud) et le RGPD (Union européenne).",
    "legal.controller_title": "Responsable du traitement",
    "legal.controller_body": "Bigradap Group Technologies (PTY) LTD — Av. Col Mondjiba 2366, C/Gombe, Kinshasa, RDC. Email : info@bigradapgroup.com.",
    "legal.data_title": "Ce que nous collectons",
    "legal.data_body": "Lorsque vous utilisez le formulaire de contact, nous stockons le nom, l'email, l'organisation, le pays, le téléphone, l'objet, le message et la langue. Nous n'utilisons pas de traceurs tiers sur bigradapgroup.com au-delà d'une analyse essentielle. Les cookies sont limités à la préférence de langue (bigradap.locale) et au jeton de session admin (bigradap.admin.token) destiné au personnel interne uniquement.",
    "legal.purpose_title": "Pourquoi nous les collectons",
    "legal.purpose_body": "Pour répondre à vos demandes et conserver une traçabilité de nos échanges commerciaux. Nous ne vendons ni ne partageons vos données avec des tiers.",
    "legal.retention_title": "Durée de conservation",
    "legal.retention_body": "Les soumissions du formulaire sont conservées 36 mois puis supprimées, sauf engagement actif nécessitant une rétention plus longue.",
    "legal.rights_title": "Vos droits",
    "legal.rights_body": "Conformément à POPIA et au RGPD, vous pouvez demander l'accès, la rectification ou la suppression de vos données et déposer une plainte auprès de l'autorité compétente. Écrivez à info@bigradapgroup.com.",
    "legal.security_title": "Sécurité",
    "legal.security_body": "Tout le trafic sur bigradapgroup.com est chiffré via HTTPS. Les soumissions sont stockées dans une instance MongoDB à accès restreint. L'accès administrateur est protégé par JWT, bcrypt et verrouillage anti-force brute.",
    "legal.terms_title": "Conditions",
    "legal.terms_body": "Le contenu de ce site appartient à Bigradap Group Technologies et ne peut être reproduit sans autorisation écrite préalable. Les noms de marque et logos appartiennent à leurs propriétaires respectifs et sont utilisés à titre illustratif.",
  },
  ar: {
    "nav.legal": "قانوني",
    "legal.tag": "قانوني",
    "legal.title": "الخصوصية والإشعارات القانونية.",
    "legal.intro": "تحترم Bigradap Group Technologies (PTY) LTD خصوصية كل زائر. توضح هذه الصفحة كيفية جمع البيانات الشخصية ومعالجتها على bigradapgroup.com وفقاً لـ POPIA و GDPR.",
    "legal.controller_title": "المسؤول عن البيانات",
    "legal.controller_body": "Bigradap Group Technologies (PTY) LTD — Av. Col Mondjiba 2366, C/Gombe, Kinshasa، جمهورية الكونغو الديمقراطية. البريد: info@bigradapgroup.com.",
    "legal.data_title": "ما الذي نجمعه",
    "legal.data_body": "عند استخدام نموذج الاتصال نخزن الاسم والبريد والمؤسسة والبلد والهاتف والموضوع والرسالة واللغة. لا نستخدم متعقبات طرف ثالث.",
    "legal.purpose_title": "لماذا نجمعها",
    "legal.purpose_body": "للرد على استفساراتك والاحتفاظ بسجل تجاري. لا نبيع بياناتك أو نشاركها.",
    "legal.retention_title": "مدة الاحتفاظ",
    "legal.retention_body": "تُحفظ الرسائل لمدة 36 شهراً ثم تُحذف ما لم تتطلب علاقة عمل نشطة احتفاظاً أطول.",
    "legal.rights_title": "حقوقك",
    "legal.rights_body": "وفقاً لـ POPIA و GDPR، يحق لك طلب الوصول أو التصحيح أو الحذف. اكتب إلى info@bigradapgroup.com.",
    "legal.security_title": "الأمن",
    "legal.security_body": "كل حركة المرور مشفرة عبر HTTPS. التخزين في MongoDB مقيد الوصول. الوصول الإداري محمي بـ JWT و bcrypt وقفل ضد محاولات القوة الغاشمة.",
    "legal.terms_title": "الشروط",
    "legal.terms_body": "محتوى هذا الموقع ملك لـ Bigradap Group Technologies ولا يجوز نسخه دون إذن خطي. تخص العلامات التجارية أصحابها.",
  },
  zh: {
    "nav.legal": "法律",
    "legal.tag": "法律",
    "legal.title": "隐私与法律声明。",
    "legal.intro": "Bigradap Group Technologies (PTY) LTD 尊重每位访问者的隐私。本页说明我们在 bigradapgroup.com 上如何收集、存储和处理个人数据,遵守 POPIA(南非)与 GDPR(欧盟)。",
    "legal.controller_title": "数据控制方",
    "legal.controller_body": "Bigradap Group Technologies (PTY) LTD — Av. Col Mondjiba 2366, C/Gombe, 金沙萨,刚果民主共和国。邮箱:info@bigradapgroup.com。",
    "legal.data_title": "我们收集什么",
    "legal.data_body": "通过联系表单我们会存储姓名、邮箱、机构、国家、电话、主题、信息与所选语言。我们不在本站使用第三方追踪。",
    "legal.purpose_title": "收集用途",
    "legal.purpose_body": "用于回复您的咨询并保留业务通讯审计轨迹。我们不出售或与第三方共享您的数据。",
    "legal.retention_title": "保留期限",
    "legal.retention_body": "联系信息保留 36 个月后删除,除非合作关系活跃需要更长保留期。",
    "legal.rights_title": "您的权利",
    "legal.rights_body": "根据 POPIA 与 GDPR,您可申请访问、更正或删除个人数据,并向监管机构投诉。请联系 info@bigradapgroup.com。",
    "legal.security_title": "安全",
    "legal.security_body": "所有流量通过 HTTPS 加密。数据存储于受限访问的 MongoDB 实例。管理访问由 JWT、bcrypt 与暴力破解锁定保护。",
    "legal.terms_title": "条款",
    "legal.terms_body": "本站内容归 Bigradap Group Technologies 所有,未经书面许可不得复制。品牌与商标归属各自所有者,仅用于示意。",
  },
  es: {
    "nav.legal": "Legal",
    "legal.tag": "Legal",
    "legal.title": "Privacidad y avisos legales.",
    "legal.intro": "Bigradap Group Technologies (PTY) LTD respeta la privacidad de cada visitante. Esta página describe cómo recopilamos, almacenamos y procesamos datos personales en bigradapgroup.com, en cumplimiento con POPIA (Sudáfrica) y el RGPD (Unión Europea).",
    "legal.controller_title": "Responsable del tratamiento",
    "legal.controller_body": "Bigradap Group Technologies (PTY) LTD — Av. Col Mondjiba 2366, C/Gombe, Kinshasa, RDC. Email: info@bigradapgroup.com.",
    "legal.data_title": "Qué recopilamos",
    "legal.data_body": "Al usar el formulario de contacto almacenamos nombre, email, organización, país, teléfono, asunto, mensaje e idioma. No usamos rastreadores de terceros en bigradapgroup.com.",
    "legal.purpose_title": "Por qué",
    "legal.purpose_body": "Para responder a sus consultas y mantener una traza de las comunicaciones comerciales. No vendemos ni compartimos sus datos.",
    "legal.retention_title": "Plazo de conservación",
    "legal.retention_body": "Los envíos del formulario se conservan 36 meses y luego se eliminan, salvo relación comercial activa.",
    "legal.rights_title": "Sus derechos",
    "legal.rights_body": "Conforme a POPIA y RGPD puede solicitar acceso, rectificación o supresión. Escriba a info@bigradapgroup.com.",
    "legal.security_title": "Seguridad",
    "legal.security_body": "Todo el tráfico está cifrado vía HTTPS. Los envíos se almacenan en una instancia MongoDB de acceso restringido. El acceso administrativo está protegido por JWT, bcrypt y bloqueo anti fuerza bruta.",
    "legal.terms_title": "Condiciones",
    "legal.terms_body": "El contenido es propiedad de Bigradap Group Technologies y no puede reproducirse sin permiso escrito. Las marcas pertenecen a sus respectivos titulares.",
  },
};

const clients = {
  en: {
    "clients.tag": "Trusted by",
    "clients.title": "A selection of clients & partners across Africa.",
    "clients.sector.telecom": "Telecom & Media",
    "clients.sector.banking": "Banking & Insurance",
    "clients.sector.gov": "Government & Public Sector",
    "clients.sector.health": "Health",
    "clients.sector.education": "Education & Research",
    "clients.sector.transport": "Transport & Industry",
    "clients.sector.electoral": "Electoral programs",
  },
  fr: {
    "clients.tag": "Ils nous font confiance",
    "clients.title": "Une sélection de clients et partenaires à travers l'Afrique.",
    "clients.sector.telecom": "Télécoms & Médias",
    "clients.sector.banking": "Banque & Assurance",
    "clients.sector.gov": "Secteur public & Gouvernement",
    "clients.sector.health": "Santé",
    "clients.sector.education": "Éducation & Recherche",
    "clients.sector.transport": "Transport & Industrie",
    "clients.sector.electoral": "Programmes électoraux",
  },
  ar: {
    "clients.tag": "يثقون بنا",
    "clients.title": "نخبة من العملاء والشركاء في أنحاء أفريقيا.",
    "clients.sector.telecom": "الاتصالات والإعلام",
    "clients.sector.banking": "البنوك والتأمين",
    "clients.sector.gov": "القطاع العام والحكومة",
    "clients.sector.health": "الصحة",
    "clients.sector.education": "التعليم والبحث",
    "clients.sector.transport": "النقل والصناعة",
    "clients.sector.electoral": "برامج انتخابية",
  },
  zh: {
    "clients.tag": "信任我们的客户",
    "clients.title": "覆盖非洲的部分客户与合作伙伴。",
    "clients.sector.telecom": "电信与媒体",
    "clients.sector.banking": "银行与保险",
    "clients.sector.gov": "公共部门与政府",
    "clients.sector.health": "卫生",
    "clients.sector.education": "教育与研究",
    "clients.sector.transport": "交通与工业",
    "clients.sector.electoral": "选举项目",
  },
  es: {
    "clients.tag": "Confían en nosotros",
    "clients.title": "Una selección de clientes y socios en África.",
    "clients.sector.telecom": "Telecom y Medios",
    "clients.sector.banking": "Banca y Seguros",
    "clients.sector.gov": "Sector Público y Gobierno",
    "clients.sector.health": "Salud",
    "clients.sector.education": "Educación e Investigación",
    "clients.sector.transport": "Transporte e Industria",
    "clients.sector.electoral": "Programas electorales",
  },
};

const cookieBanner = {
  en: { "cookie.text": "We use a single cookie to remember your language. No tracking.", "cookie.accept": "OK", "cookie.learn": "Learn more" },
  fr: { "cookie.text": "Nous utilisons un seul cookie pour mémoriser votre langue. Aucun pistage.", "cookie.accept": "OK", "cookie.learn": "En savoir plus" },
  ar: { "cookie.text": "نستخدم ملف تعريف ارتباط واحدًا لتذكر لغتك. لا تتبع.", "cookie.accept": "موافق", "cookie.learn": "اعرف المزيد" },
  zh: { "cookie.text": "我们只使用一个 Cookie 记住您的语言偏好。无追踪。", "cookie.accept": "好的", "cookie.learn": "了解更多" },
  es: { "cookie.text": "Usamos una sola cookie para recordar su idioma. Sin rastreo.", "cookie.accept": "OK", "cookie.learn": "Más info" },
};

const mapAndCases = {
  en: {
    "map.tag": "Continental footprint",
    "map.title": "13 countries — and counting.",
    "map.sub": "From our Kinshasa headquarters to electoral and civil-identity programs across the continent. Hover or tap a highlighted country to learn more.",
    "map.legend_served": "Programs delivered",
    "map.legend_other": "Other African countries",
    "map.programs_label": "Countries served",
    "cases.tag": "Case studies",
    "cases.title": "Selected country programs.",
    "cases.sub": "Each program is staffed by sector specialists and adapted to the local regulatory context.",
    "cases.cta": "Discuss a similar program",
  },
  fr: {
    "map.tag": "Empreinte continentale",
    "map.title": "13 pays — et plus à venir.",
    "map.sub": "Depuis notre siège de Kinshasa, vers des programmes électoraux et d'identité civile à travers le continent. Survolez ou touchez un pays mis en évidence pour en savoir plus.",
    "map.legend_served": "Programmes livrés",
    "map.legend_other": "Autres pays africains",
    "map.programs_label": "Pays servis",
    "cases.tag": "Études de cas",
    "cases.title": "Programmes pays sélectionnés.",
    "cases.sub": "Chaque programme est porté par des spécialistes sectoriels et adapté au contexte réglementaire local.",
    "cases.cta": "Discuter d'un programme similaire",
  },
  ar: {
    "map.tag": "حضور قاري",
    "map.title": "13 دولة — والعدد يتزايد.",
    "map.sub": "من مقرنا في سنتشريون وكينشاسا إلى برامج انتخابية وهوية مدنية عبر القارة. حرّك المؤشر فوق أي دولة مميزة لمعرفة المزيد.",
    "map.legend_served": "برامج مُنفَّذة",
    "map.legend_other": "دول أفريقية أخرى",
    "map.programs_label": "دول مخدومة",
    "cases.tag": "دراسات حالة",
    "cases.title": "برامج قُطرية مختارة.",
    "cases.sub": "يقود كل برنامج متخصصون قطاعيون ويُكيَّف مع السياق التنظيمي المحلي.",
    "cases.cta": "ناقش برنامجاً مماثلاً",
  },
  zh: {
    "map.tag": "大陆覆盖",
    "map.title": "13 个国家——并在持续扩展。",
    "map.sub": "从金沙萨总部出发,我们在非洲大陆交付选举与公民身份项目。将光标悬停在高亮国家上以了解更多。",
    "map.legend_served": "已交付项目",
    "map.legend_other": "其他非洲国家",
    "map.programs_label": "服务国家",
    "cases.tag": "案例研究",
    "cases.title": "精选国家项目。",
    "cases.sub": "每个项目均由行业专家驱动,并针对当地监管环境进行定制。",
    "cases.cta": "讨论类似项目",
  },
  es: {
    "map.tag": "Huella continental",
    "map.title": "13 países — y creciendo.",
    "map.sub": "Desde nuestra sede de Kinshasa hasta programas electorales y de identidad civil en todo el continente. Pase el cursor sobre un país resaltado para saber más.",
    "map.legend_served": "Programas entregados",
    "map.legend_other": "Otros países africanos",
    "map.programs_label": "Países atendidos",
    "cases.tag": "Casos",
    "cases.title": "Programas país seleccionados.",
    "cases.sub": "Cada programa cuenta con especialistas sectoriales y se adapta al contexto regulatorio local.",
    "cases.cta": "Hablar de un programa similar",
  },
};

const extras = { founder, careers, legal, clients, cookieBanner, mapAndCases };

export default extras;
